// custom js bbb code

$(document).ready(function(){

// sticky header
        //add for sticky menu
        //offset() measures how far down the sticky element is from the top of the window
        var stickyTop = $(".header-fixed--true").offset().top;
        //whenever the user scrolls, measure how far we have scrolled
        $(window).scroll(function() {
          var windowTop = $(window).scrollTop();
          //check to see if we have scrolled past the original location of the sticky element
          if (windowTop > stickyTop) {
            //if so, change the sticky element to fised positioning
            $(".desktop-nav").addClass("stuck");
            $("body").addClass("sticky-main");
            // $(".top_bar").addClass("no-stuck");
          } else {
            $(".desktop-nav").removeClass("stuck");
            $("body").removeClass("sticky-main");
            // $(".top_bar").removeClass("no-stuck");
          }
        });

// sticky header

//on click pdp thumbnails

// $(".product_gallery_nav .gallery-cell img").on("click", function () {
//   setTimeout(
//     function(){
//   // alert('here');
// $(".gallery-wrapper").addClass("sliderPopUp");
//   // $('#customSlider').slick('setPosition');
//   // $(".product-template .product_gallery_nav.product_gallery_nav--bottom-slider").removeData("flexslider");
//   //  $('.product-template .product_gallery_nav.product_gallery_nav--bottom-slider').flickity({
//   //     "asNavFor": ".product_gallery",
//   //     "adaptiveHeight": true,
//   //     "wrapAround": true,
//   //     "cellAlign": "center",
//   //     "draggable": true,
//   //     "groupCells": false,
//   //     "prevNextButtons":  false,
//   //     "pageDots": false,
//   //     "lazyLoad": 2,
//   //     "dragThreshold": 10
//   //   });
//   $('body').css('overflow-y','hidden');
//   // $('#product-box .col-md-7').removeClass('creSlickySide')
//   }, 100);

// });

// $(".pdp-close-popup").on("click", function () {
//   // $('.creSlidermain video').trigger('pause');
//   $(".gallery-wrapper").removeClass("sliderPopUp");
//   // $('#customSlider').slick('setPosition');
// $(".product-template .product_gallery_nav.product_gallery_nav--bottom-slider").removeData("flexslider");
//    $('.product-template .product_gallery_nav.product_gallery_nav--bottom-slider').flickity({
//       "asNavFor": ".product_gallery",
//       "adaptiveHeight": true,
//       "wrapAround": true,
//       "cellAlign": "center",
//       "draggable": true,
//       "groupCells": false,
//       "prevNextButtons":  false,
//       "pageDots": false,
//       "lazyLoad": 2,
//       "dragThreshold": 10
//     });
//   $('body').css('overflow-y','auto');
//   // $('#product-box .col-md-7').addClass('creSlickySide')
// });


// Content tabs begin
$('.content-tabs li a:not(:first)').addClass('inactive');
$('.tab-content').hide();
$('.tab-content:first').show();

$('.content-tabs li a').click(function(){
  var t = $(this).attr('id');
  if($(this).hasClass('inactive')){ //this is the start of our condition 
    $('.content-tabs li a').addClass('inactive');           
    $(this).removeClass('inactive');

    $('.tab-content').hide();
    $('#'+ t + 'C').fadeIn('slow');
  }
});

// Content tabs end

//shipping page selector
$('#shipping-cost__select').on('change', function() {
  $(".country-cost").each(function(){
    $(this).removeClass('show');
});
  
  $('#shipping-cost__based-value .country-'+this.value).addClass('show');
});
//shipping page selector


// bbb slideshow autoplay
$(".homepage-slideshow").on("mouseleave", function() {
    $(this).flickity("playPlayer");
});
$(".homepage-slideshow").on("click touchstart",function() {
    $(this).flickity("playPlayer");
});
  
});